import { paginateChecklistItems } from '@st/formation'
import type { STChecklistItem } from '@st/sdk'
import { parseMimeType } from '@st/util/mime'

export type ViewerDocKind = 'none' | 'pdf' | 'formation' | 'formation-checklist'

export function resolveViewerDocKind(mimeType: string | undefined): ViewerDocKind {
  if (!mimeType) {
    return 'pdf'
  }

  const mime = parseMimeType(mimeType)
  if (!mime || mime.type != 'application') {
    return 'pdf'
  }

  if (mime.subtype == 'formation') {
    return 'formation'
  }
  if (mime.subtype == 'formation-checklist') {
    return 'formation-checklist'
  }

  return 'pdf'
}

export function resolveChecklistViewerPages(checklistItems: STChecklistItem[]) {
  return paginateChecklistItems(checklistItems).map((page) => ({
    pageNumber: page.number,
    width: 1000,
    height: 1410
  }))
}
